/**
 * @file: ProductReferralFeeItemType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ProductReferralFeeItemType {
  ReferringFee = 'referring_fee',
  AdoptionFee = 'adoption_fee',
  ClosingFee = 'closing_fee',
}

export const ProductReferralFeeItemTypeValueSet = new Set([
  ProductReferralFeeItemType.ReferringFee,
  ProductReferralFeeItemType.AdoptionFee,
  ProductReferralFeeItemType.ClosingFee,
]);
